const clearLocalStorage = function () {
  // 清除token
  localStorage.removeItem('sessionId')
  localStorage.removeItem('userInfo')
}
export {clearLocalStorage}



// WEBPACK FOOTER //
// ./src/utils/clearLocalStorage.js